import React, { useEffect, useState } from "react";
import { Stack, Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../layout/dashboard/header";

import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../hooks/useAuth";
import { getUrlPathId } from "../../utils/url-id";
import { useNotificationService } from "../../components/notification";
import { apiGetScheduleById } from "../../api/schedules";
import { ScheduleData, ScheduleDummyData } from "../../interface/schedule";
import ScheduleDetailsInfo from "../../components/schedule/ScheduleDetailsInfo";
import ScheduleDetailsContent from "../../components/schedule/ScheduleDetailsContent";
import BackButton from "../../components/UIElements/BackButton";

export default function ScheduleDetails() {
  const theme = useTheme();
  const location = useLocation();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const [schedule_info, setSchedule_info] =
    useState<ScheduleData>(ScheduleDummyData);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const scheduleId = getUrlPathId(location?.pathname);
    const fields = { scheduleId, token };
    mutation.mutate(fields);
  }, [refresh]);

  const mutation = useMutation({
    mutationFn: (fields: { token: string; scheduleId: string }) =>
      apiGetScheduleById(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        if (Array.isArray(data?.data?.data)) {
          setSchedule_info(data.data.data[0]);
        } else {
          setSchedule_info(data.data.data);
        }
      }
    },
    onError: (error) => {
      console.error("Fetch process failed", error);
      showNotification("Fetch process failed", "error");
    },
  });
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Schedule Information
            </Typography>
          </Stack>
        </Box>
      </Header>

      <ScheduleDetailsContent
        setRefresh={setRefresh}
        scheduleInfo={schedule_info}
      />
    </>
  );
}
